import React from "react";
import { useNavigate } from "react-router";

type ChatMessageProps = {
  message: {
    id?: string;
    user_id?: string | null;
    nickname?: string | null;
    content: string;
    created_at: string;
  };
};

const ChatMessage = React.memo(({ message }: ChatMessageProps) => {
  const navigate = useNavigate();

  const displayName = message.nickname || "Anonymous";
  const isClickable = !!message.user_id;

  const handleClick = () => {
    if (!message.user_id || !message.nickname) return;
    navigate(`/profile/${message.nickname}`);
  };

  return (
    <div className="flex gap-2 items-baseline text-sm">
      {/* Time */}
      <span className="text-xs text-gray-400 shrink-0">
        {new Date(message.created_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </span>

      {/* Username */}
      {isClickable ? (
        <button onClick={handleClick} className="text-emerald-400 font-semibold shrink-0 hover:underline cursor-pointer">
          {displayName}:
        </button>
      ) : (
        <span className="text-emerald-400 font-semibold shrink-0">{displayName}:</span>
      )}

      {/* Content */}
      <span className="text-lime-300 break-words drop-shadow-[0_0_10px_rgba(190,242,100,0.5)]">
        {message.content}
      </span>
    </div>
  );
});

export default ChatMessage;
